import {
  FileInput,
  LoadingOverlay,
  TextInput,
  Textarea,
  rem,
  Anchor,
  Box,
  Button,
  Checkbox,
  Loader,
  Flex,
  Group,
  Select,
  Text,
  ScrollArea,
} from "@mantine/core";
import { isNotEmpty, useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconCheck, IconFileCv, IconX } from "@tabler/icons-react";
import { tblBanner, tblBannerLocation } from "../../../model/TblBanner";
import {
  getDataBannerLocation,
  modifyBanner,
} from "../../../api/ApiBannerManager";
import { CategoryTree } from "../../../model/TblCategoryCommand";
import { DateInput, DateTimePicker } from "@mantine/dates";
import moment from "moment";
import React, { useEffect, useState } from "react";
import ImageShow from "../../../_base/component/_image";
import Repository from "../../../_base/helper/HttpHelper";
import { API_ROUTE } from "../../../const/apiRoute";
import {
  isNullOrUndefined,
  isNullOrUndefinedArry,
} from "../../../_base/extension/StringExtension";
import { MessageResponse } from "../../../model/MessageResponse";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import {
  formatDateToString,
  urlToImageFile,
} from "../../../_base/helper/FunctionHelper";
import ButtonClose from "../../../common/ButtonClose/ButtonClose";
import { uploadImageAddFolder } from "../../../api/ApiMore";

const icon = (
  <IconFileCv style={{ width: rem(18), height: rem(18) }} stroke={1.5} />
);

const EditView = ({ id, onSearch }: { id: number; onSearch: any }) => {
  const [dataCategory, setDataCategory] = useState<CategoryTree[]>([]);
  const [iconimage, setIconImage] = useState<string>("");
  const [error, setError] = useState<string | undefined>();
  const [isImageChange, setIsImageChange] = useState<boolean>(false);
  const [selectedValues, setSelectedValues] = useState<any[]>([]);
  const [dataBannerLocation, setDataBannerLocation] = useState<
    tblBannerLocation[]
  >([]);
  const [dataOptionBannerLocation, setDataOptionBannerLocation] = useState<
    any[]
  >([]);
  const [displayType, setDisplayType] = useState<string | null>(null);
  const [fromDateValue, setFromDateValue] = useState<Date | null>(null);
  const [toDateValue, setToDateValue] = useState<Date | null>(null);
  const [urlImageUpload, setUrlImageUpload] = useState<string>("");
  const [loadingImage, setLoadingImage] = useState<number>(0);

  const entity = {
    id: 0,
    code: null,
    name: null,
    bannerUrlPrimary: null,
    linkPage: null,
    bannerLocationId: null,
    title: null,
    bannerWidth: null,
    bannerHeight: null,
    fileBanner: null,
    bannerUrl: null,
    bannerUrlTarget: null,
    orderNumber: null,
    description: null,
    fromDate: null,
    toDate: null,
    fromTime: null,
    toTime: null,
    status: null,
    type: null,
    mobileStatus: null,
    templatePage: null,
    locationIndex: null,
    creationDate: null,
    createdBy: null,
    lastUpdateDate: null,
    lastUpdatedBy: null,
    lastUpdateLogin: null,
    listCategoryId: null,
  };

  const handleEditBanner = async (dataSubmit: tblBanner) => {
    open();
    let data: any = {};
    const { fileBanner, ...restGroup } = dataSubmit;
    if (isImageChange) {
      data = dataSubmit;
    } else data = restGroup;
    try {
      await modifyBanner({
        ...data,
        bannerLocationId: data.bannerLocationId
          ? Number(data.bannerLocationId)
          : 0,
        fromDate: data.type !== "LIMIT" ? null : data.fromDate,
        toDate: data.type !== "LIMIT" ? null : data.toDate,
        fileBanner: urlImageUpload.length > 0 ? urlImageUpload : null,
      });
      close();
      modals.closeAll();
      onSearch();
    } catch (error) {
      console.error("Error saving banner:", error);
      close();
    }
  };

  const [visible, { toggle, close, open }] = useDisclosure(false);

  const form = useForm<tblBanner>({
    mode: "uncontrolled",
    initialValues: {
      ...entity,
    },
    validate: {
      bannerLocationId: isNotEmpty("Chưa chọn vị trí Banner"),
      name: isNotEmpty("Tên banner chưa nhập"),
      // code: isNotEmpty("Mã banner chưa nhập"),
      // bannerWidth: isNotEmpty("Chiều rộng banner chưa nhập"),
      // bannerHeight: isNotEmpty("Chiều dài banner chưa nhập"),
      // fileBanner: isNotEmpty("Chưa chọn File Banner"),
      bannerUrlTarget: isNotEmpty("Link URL đích chưa nhập"),
      status: isNotEmpty("Loại hiển thị chưa chọn"),
      type: isNotEmpty("Loại hiển thị chưa chọn"),
      orderNumber: isNotEmpty("Thứ tự hiển thị chưa nhập"),
    },
  });

  console.log(form.getValues());

  const handleChangeImage = (file: File | null) => {
    // form.getInputProps("fileBanner").onChange(file);
    form.setValues((prev) => ({
      ...prev,
      fileBanner: file,
    }));
    setIsImageChange(true);
  };

  const loadDataBannerLocation = async () => {
    setDataBannerLocation([]);
    const data = await getDataBannerLocation("Active=true&Skip=0&Take=1000");
    setDataBannerLocation(data?.data);
  };

  const handleClickCategoryName = (id: number) => {
    var element = document.getElementById(id.toString());
    if (element) {
      element.style.display =
        element.style.display === "block" ? "none" : "block";
    }
  };

  const handleChangeCheckBox = (categoryId: number, checked: boolean) => {
    if (checked) {
      setSelectedValues([...selectedValues, categoryId]);
    } else {
      setSelectedValues(selectedValues.filter((value) => value !== categoryId));
    }
  };

  const flattenCategoryTree = (
    categories: CategoryTree[],
    level = 0,
    idParent = 0
  ) => {
    return (
      <div
        id={idParent.toString()}
        style={{ display: level ? "none" : "block" }}
      >
        {categories?.flatMap((category) => {
          return (
            <React.Fragment key={category?.id}>
              <Flex pl={level * 30} mt={5}>
                <Text mr={5} mt={-3}>
                  +
                </Text>
                <Checkbox
                  label={
                    category?.categoryChildModels.length > 0 ? (
                      <Anchor
                        underline="always"
                        href="javascript:void(0)"
                        onClick={() => handleClickCategoryName(category?.id)}
                      >
                        {category?.categoryName}
                      </Anchor>
                    ) : (
                      <Text>{category?.categoryName}</Text>
                    )
                  }
                  checked={selectedValues.includes(category?.id)}
                  onChange={(e) =>
                    handleChangeCheckBox(category?.id, e.currentTarget.checked)
                  }
                />
              </Flex>

              {category?.categoryChildModels.length > 0 &&
                flattenCategoryTree(
                  category.categoryChildModels,
                  level + 1,
                  category.id
                )}
            </React.Fragment>
          );
        })}
      </div>
    );
  };

  const handleUploadImage = async (files: File[] | File) => {
    if (!files) {
      NotificationExtension.Fails("File sai định dạng hoặc không tồn tại !");
      return;
    }

    const newDate = formatDateToString(new Date());
    const fileArray = Array.isArray(files) ? files : [files];

    if (fileArray.length === 0) {
      NotificationExtension.Fails("File sai định dạng hoặc không tồn tại !");
      return;
    } else {
      const res = await uploadImageAddFolder(
        `cdn/Media/Image/Banner/${newDate}`,
        fileArray
      );

      if (res && res.success) {
        const data = res?.data[0]?.url;
        setTimeout(() => {
          NotificationExtension.Success("Tải ảnh lên thành công !");
        }, 1000);
        setUrlImageUpload(data);
        setLoadingImage((prev) => prev + 1);
      } else {
        NotificationExtension.Fails(res?.message);
        form.setValues((prev) => ({ ...prev, fileBanner: null }));
      }
    }
  };

  useEffect(() => {
    loadDataBannerLocation();
  }, []);

  useEffect(() => {
    const callDataCategoryTree = async () => {
      // setLoading(true);
      // setError(undefined);
      try {
        const repository = new Repository(
          process.env.REACT_APP_Demo_APP_API_URL
        );
        let urlSearch =
          API_ROUTE.GET_CATEGORY_TREE +
          `?CategoryType=category&IsTradeIn=N&Skip=0&Take=2000`;
        let callapi = await repository.get<MessageResponse<CategoryTree[]>>(
          urlSearch
        );
        if (
          isNullOrUndefined(callapi) ||
          isNullOrUndefinedArry(callapi?.data)
        ) {
          setDataCategory([]);
        } else {
          setDataCategory(callapi?.data ?? []);
        }
        return callapi?.data;
      } catch (error: any) {
        setError("Có lỗi xảy ra khi tải dữ liệu !");
        return null;
      } finally {
        // setLoading(false);
      }
    };
    callDataCategoryTree();
  }, []);

  useEffect(() => {
    setDataOptionBannerLocation(
      dataBannerLocation.map((option) => {
        if (option.status === "A")
          return { value: option.id.toString(), label: option.bannerLocName };
        else
          return {
            value: option.id.toString(),
            label: option.bannerLocName,
          };
      })
    );
  }, [dataBannerLocation]);

  useEffect(() => {
    const callApiGetData = async () => {
      const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
      open();
      const urlDetail = `TblBanner/get-detail/` + id;
      let callApi = await repository.get<MessageResponse<tblBanner>>(urlDetail);
      if (!isNullOrUndefined(callApi) && !isNullOrUndefined(callApi?.data)) {
        const dataApi = callApi?.data;
        setUrlImageUpload(String(dataApi?.fileBanner));
        if (dataApi != null && !isNullOrUndefined(dataApi)) {
          if (
            dataApi.fileBanner !== null &&
            dataApi.fileBanner !== undefined &&
            typeof dataApi.fileBanner == "string"
          ) {
            setIconImage(dataApi.fileBanner);
            const fileResult = await urlToImageFile(dataApi.fileBanner);
            if (fileResult !== null) {
              dataApi.fileBanner = fileResult;
            }
          }
          const listCategoryId = dataApi?.listCategoryId;
          const cleanedListCategoryId = listCategoryId?.replace(/^"|"$/g, ""); // Loại bỏ dấu " ở đầu và cuối

          const array = cleanedListCategoryId
            ? cleanedListCategoryId
                .split(",") // Tách chuỗi thành mảng
                .map((value) => {
                  const trimmedValue = value.trim(); // Loại bỏ khoảng trắng
                  const num = Number(trimmedValue); // Chuyển đổi thành số
                  return !isNaN(num) ? num : null; // Nếu không phải số, trả về null
                })
                .filter((value) => value !== null) // Loại bỏ các giá trị null
            : [];

          setSelectedValues(array);

          // Cập nhật displayType khi nhận dữ liệu từ API
          if (dataApi.type) {
            setDisplayType(dataApi.type);
          }

          // Cập nhật giá trị ngày tháng
          if (dataApi.fromDate) {
            setFromDateValue(new Date(dataApi.fromDate));
          }

          if (dataApi.toDate) {
            setToDateValue(new Date(dataApi.toDate));
          }

          form.setValues({
            ...dataApi,
            bannerLocationId: dataApi.bannerLocationId
              ? dataApi.bannerLocationId.toString()
              : "",
          });
        } else {
          NotificationExtension.Fails("Dữ liệu không tồn tại");
          modals.closeAll();
        }
        close();
      } else {
        NotificationExtension.Fails("Dữ liệu không tồn tại");
        modals.closeAll();
      }
    };
    callApiGetData();
  }, [id]);

  useEffect(() => {
    // Loại bỏ các giá trị 0 khỏi selectedValues
    const filteredValues = selectedValues.filter((value) => value !== 0);
    if (filteredValues.length === 0) {
      form.setFieldValue("listCategoryId", null); // Không chọn gì thì truyền null
    } else {
      const dataToString = filteredValues.join(","); // Không cần khoảng trắng
      form.setFieldValue("listCategoryId", dataToString);
    }
  }, [selectedValues]);
  // Theo dõi thay đổi của form.values.type và cập nhật displayType
  useEffect(() => {
    if (form.values.type) {
      setDisplayType(form.values.type);
    }
  }, [form.values.type]);

  useEffect(() => {
    if (isImageChange) {
      const fileBanner = form.getValues()?.fileBanner;
      if (fileBanner && fileBanner instanceof File) {
        handleUploadImage(fileBanner);
      }
    }
  }, [form.getValues()?.fileBanner]);

  // // Cập nhật state địa phương khi giá trị form thay đổi
  // useEffect(() => {
  //   if (form.values.fromDate) {
  //     setFromDateValue(new Date(form.values.fromDate));
  //   }
  // }, [form.values.fromDate]);

  // useEffect(() => {
  //   if (form.values.toDate) {
  //     setToDateValue(new Date(form.values.toDate));
  //   }
  // }, [form.values.toDate]);
  return (
    <>
      <Box
        className="flex-none"
        component="form"
        w={"82.5vw"}
        maw={1250}
        mx="auto"
        onSubmit={form.onSubmit(async (values) => {
          await handleEditBanner(values);
        })}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />

        <Group grow wrap="nowrap" mt="lg" gap={"lg"}>
          <Select
            label={"Vị trí Banner"}
            placeholder={""}
            withAsterisk
            clearable
            data={dataOptionBannerLocation}
            nothingFoundMessage="Không có dữ liệu"
            key={form.key("bannerLocationId")}
            {...form.getInputProps("bannerLocationId")}
          />
        </Group>

        <Group grow wrap="nowrap" mt="lg" gap={"lg"}>
          <Box>
            <Text mt={"xs"} fw={600}>
              Hãy chọn danh mục cho banner
            </Text>
            {dataCategory.length > 0 ? (
              <ScrollArea h={250}>
                <Box>{flattenCategoryTree(dataCategory || [])}</Box>
              </ScrollArea>
            ) : (
              <Loader color="indigo" type="bars" />
            )}
          </Box>
        </Group>

        <Group grow wrap="nowrap" mt="lg" gap={"lg"}>
          <TextInput
            label={"Tên banner"}
            placeholder={"Nhập tên"}
            withAsterisk
            mt="md"
            type="text"
            key={form.key("name")}
            {...form.getInputProps("name")}
          />
          {/* <TextInput
            label={"Mã banner"}
            placeholder={"Nhập mã"}
            withAsterisk
            mt="md"
            type="text"
            key={form.key("code")}
            {...form.getInputProps("code")}
          /> */}
        </Group>

        <Group grow wrap="nowrap" mt="lg" gap={"lg"}>
          <Textarea
            label={"Ghi chú / Mô tả"}
            placeholder={"Nhập ghi chú"}
            mt="md"
            key={form.key("description")}
            {...form.getInputProps("description")}
          />
        </Group>

        <Group grow wrap="nowrap" mt="lg" gap={"lg"}>
          <TextInput
            label={"Chiều dài (width)"}
            placeholder={"Nhập chiều dài"}
            mt="md"
            type="number"
            key={form.key("bannerWidth")}
            {...form.getInputProps("bannerWidth")}
          />
          <TextInput
            label={"Chiều cao (height"}
            placeholder={"Nhập chiều cao"}
            mt="md"
            type="number"
            key={form.key("bannerHeight")}
            {...form.getInputProps("bannerHeight")}
          />
        </Group>

        <Group grow wrap="nowrap" mt="lg" gap={"lg"}>
          <FileInput
            leftSection={icon}
            label={"Ảnh đại diện"}
            placeholder={"Chọn ảnh"}
            accept="image/png,image/jpeg"
            value={form.getValues()?.fileBanner}
            clearable
            mt="md"
            mb="md"
            // key={form.key("fileBanner")}
            {...form.getInputProps("fileBanner")}
            onChange={handleChangeImage}
          />
          {urlImageUpload.length > 0 ? (
            <ImageShow
              h={200}
              w={300}
              img={urlImageUpload}
              loading={loadingImage}
            />
          ) : iconimage ? (
            <ImageShow h={200} w={300} img={iconimage} />
          ) : (
            <Box></Box>
          )}
        </Group>

        <Group grow wrap="nowrap" mt="lg" gap={"lg"}>
          <TextInput
            label={"Hoặc dán link ảnh có sẵn"}
            placeholder={""}
            mt="md"
            type="text"
            key={form.key("bannerUrl")}
            {...form.getInputProps("bannerUrl")}
          />
        </Group>

        <Group grow wrap="nowrap" mt="lg" gap={"lg"}>
          <TextInput
            label={"Địa chỉ URL đích"}
            placeholder={"Nhập chiều dài"}
            withAsterisk
            mt="md"
            type="text"
            key={form.key("bannerUrlTarget")}
            {...form.getInputProps("bannerUrlTarget")}
          />
        </Group>

        <Group grow wrap="nowrap" mt="lg" gap={"lg"}>
          <TextInput
            label={"Thứ tự hiển thị"}
            placeholder={"Nhập thứ tự"}
            withAsterisk
            mt="md"
            type="number"
            key={form.key("orderNumber")}
            {...form.getInputProps("orderNumber")}
          />
          <Select
            label={"Loại hiển thị"}
            placeholder={""}
            withAsterisk
            mt="md"
            data={[
              {
                value: "ALWAYS",
                label: "Luôn hiển thị, chỉ ẩn khi hạ bằng tay",
              },
              {
                value: "LIMIT",
                label: "Thời gian hiển thị",
              },
            ]}
            key={form.key("type")}
            {...form.getInputProps("type")}
            clearable
            onChange={(value) => {
              form.getInputProps("type").onChange(value);
              setDisplayType(value);
            }}
          />
        </Group>
        {displayType === "LIMIT" && (
          <Group grow wrap="wrap" gap={"lg"}>
            <DateInput
              value={fromDateValue}
              valueFormat="DD/MM/YYYY"
              onChange={(value) => {
                setFromDateValue(value);
                if (value) {
                  form.setFieldValue(
                    "fromDate",
                    moment(value).format("YYYY-MM-DD[T]HH:mm:ss")
                  );
                } else {
                  form.setFieldValue("fromDate", null);
                }
              }}
              mt="md"
              label="Ngày bắt đầu"
              placeholder="Ngày bắt đầu"
              clearable
            />
            <DateInput
              value={toDateValue}
              valueFormat="DD/MM/YYYY"
              onChange={(value) => {
                setToDateValue(value);
                if (value) {
                  form.setFieldValue(
                    "toDate",
                    moment(value).format("YYYY-MM-DD[T]HH:mm:ss")
                  );
                } else {
                  form.setFieldValue("toDate", null);
                }
              }}
              mt="md"
              label="Ngày kết thúc"
              placeholder="Ngày kết thúc"
              clearable
            />
          </Group>
        )}
        <Group grow wrap="nowrap" mt="lg" gap={"lg"}>
          <Select
            label={"Hiển thị"}
            withAsterisk
            placeholder={""}
            data={[
              {
                value: "A",
                label: "Hiển thị",
              },
              {
                value: "I",
                label: "Không hiển thị",
              },
            ]}
            key={form.key("status")}
            {...form.getInputProps("status")}
            clearable
          />
          <Select
            label={"Khác"}
            placeholder={""}
            data={[
              {
                value: "A",
                label: "Hiển thị tại mobile",
              },
              {
                value: "I",
                label: "Không hiển thị tại mobile",
              },
            ]}
            key={form.key("mobileStatus")}
            {...form.getInputProps("mobileStatus")}
            clearable
          />
        </Group>

        <Group
          justify="center"
          mt="xs"
          p="5px 0"
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
          }}
        >
          <Button
            type="submit"
            color="#3598dc"
            loading={visible}
            leftSection={!visible ? <IconCheck size={18} /> : undefined}
          >
            Lưu
          </Button>
          <ButtonClose />
        </Group>
      </Box>
    </>
  );
};

export default EditView;
